import React from 'react'
import { useParams } from 'react-router-dom';
import './edit.css';
import Formd from './Form_d';
// import Form2d from './Form2d';
export default function Editpage() {
    var {id}=useParams();
    console.log(id);
  return (
    <div className='edit_one'>
        <h2 id='h_e_2'>Edit Page</h2>
        {/* <Form2d prop={{name_:"ashad"}} /> */}
        <Formd prop={id} />
    </div>
  )
}
